/** Matches demo project ids used elsewhere in mock dashboards */
export const DEMO_TIMELINE_PROJECTS: readonly { id: string, name: string }[] = [
  { id: 'Z_xiqjD8_Rus64aR', name: 'General Work' },
  { id: 'Y_lmn45P_Qrt78bS', name: 'Marketing Campaign' },
  { id: 'X_opq23R_Pst91cT', name: 'UI/UX Redesign' },
  { id: 'W_uvw67S_Ouv04dU', name: 'Backend Migration' },
  { id: 'V_xyz89T_Nwx17eV', name: 'Customer Onboarding' },
];
